import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

function TabPanel({ children, index, value, ...other }) {
  return (
    <Box role="tabpanel" hidden={value !== index} {...other}>
      {children}
    </Box>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

TabPanel.defaultProps = {
  children: null,
}

export default TabPanel
